/* eslint-disable prettier/prettier */
import React from 'react';

export default (text) => {
	let newTextArray = [];
	let listItems = [];

	newTextArray = text.split('\n');
	newTextArray = newTextArray.map((i) => (i.startsWith('*') ? <li>{i.replace('*', '')}</li> : <p>{i}</p>));
	listItems = newTextArray.filter((i) => i.type === 'li');
	newTextArray = newTextArray.filter((i) => i.type !== 'li');
	newTextArray.push(React.createElement('ul', null, listItems));
	return newTextArray;
};
